import UserIcon from "app/components/Icons/UserIcon";
import ProfileAvatar from "app/components/ProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import { filterActiveTeamMembers, getMembersByIds } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import { ticketGroupsActions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import React, { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

interface CustomProps {
  assignedTo: string;
  onOpen: () => void;
  onClose: () => void;
}
export const AssigneeButton: FC<CustomProps> = ({
  assignedTo,
  onClose,
  onOpen,
}) => {
  const dispatch = useDispatch();
  const members = useSelector(selectProjectMemberList);
  const activeMembers = filterActiveTeamMembers(members || []);
  const owner = useMemo(() => {
    return getMembersByIds(activeMembers, assignedTo)[0];
  }, [activeMembers, assignedTo]);

  const handleSelect = (member: IMemberList) => {
    dispatch(
      ticketGroupsActions.setTicketFormValue({ name: "assignedTo", value: member?._id })
    );
  };
  return (
    <MemberSelection
      trigger={
        <button className="flex items-center justify-center w-[28px] h-[28px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2]  hover:border-[#E9ECF2] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max ">
          {owner ? (
            <div className="flex items-center gap-2">
              <UserIcon size={16} />
              <ProfileAvatar
                name={owner?.name}
                avatar={owner?.avatar}
                circleClassName=" text-[6.4px] leading-[19.2px] font-normal !size-[18px]"
                statusClassName="size-[3px]"
              />
              <span className=" text-sm font-normal text-black truncate ">
                {owner?.name as string}
              </span>
            </div>
          ) : (
            <CustomTooltip text="Set assignee">
              <UserIcon />
            </CustomTooltip>
          )}
        </button>
      }
      selectedValue={assignedTo}
      updateValue={handleSelect}
      align="center"
      headingText="Members"
      searchPlaceholder="Search by assignee or role "
      onClose={onClose}
      onOpen={onOpen}
      options={activeMembers}
    />
  );
};
